type ServiceAnalyticsObjectType = {
    sku: string,
    name: string,
    categories: string[],
    price: string,
    quantity: number,
};

export default function initTrackingEvents() : void {
    document.addEventListener('axeptio_ready', () => {
        if (typeof window._mtm !== 'undefined' && 'mtm.Start' === window._mtm[0].event) {
            // Page view
            window._mtm.push({
                event: 'page_view',
                url: window.pageview_url ? window.location.origin + window.pageview_url : window.location.href,
            });

            // Open the add to cart modal
            document.addEventListener('modal_ajax_content_loaded', evt => {
                // Send event when opening the add_to_cart modal
                if ('add_to_cart' === evt.detail.action) {
                    const $title = evt.detail.$modal.querySelector<HTMLElement>('h3, h2');
                    const popupName = $title ? $title.innerText : 'ID service : ' + evt.detail.serviceId;

                    window._mtm.push({
                        event: 'popup_view',
                        popup_name: popupName,
                    });
                }
            });

            /**
             * Return the service object for analytics
             * 
             * @param {PaymentDetailServiceType} service 
             * 
             * @return {ServiceAnalyticsObjectType}
             */
            const getServiceAnalyticsObject = (service: PaymentDetailServiceType) : ServiceAnalyticsObjectType => {
                const variant = [];

                if (service.face_to_face) {
                    variant.push('Face à face : ' + service.face_to_face);
                }

                if (service.optional_product) {
                    variant.push('Produit optionel : ' + service.optional_product);
                }

                return {
                    sku: service.name,
                    name: service.name,
                    categories: [service.type as string, service.duration, variant.join(' + ')],
                    price: parseFloat(service.price.toString()).toFixed(2),
                    quantity: service.quantity,
                };
            };

            // Add to cart
            document.addEventListener('add_to_cart', evt => {
                window._mtm.push({
                    event: 'cart_update',
                    ecommerce: {
                        cart: {
                            total: evt.detail.cart.total,
                            products: evt.detail.cart.products.map(service => getServiceAnalyticsObject(service)),
                        },
                    },
                });
            });

            // Payment done
            if ('undefined' !== typeof paymentDetail) {
                window._mtm.push({
                    event: 'purchase',
                    ecommerce: {
                        purchase: {
                            id: paymentDetail.transaction_id,
                            revenue: parseFloat(paymentDetail.transaction_value.toString()).toFixed(2),
                            orderSubTotal: parseFloat(paymentDetail.transaction_value_without_tax.toString()).toFixed(2), // revenue - tax - shipping
                            tax: parseFloat(paymentDetail.tax || '0').toFixed(2),
                            shipping: 0, // Shipping price
                            discount: false,
                            products: paymentDetail.services.map(service => getServiceAnalyticsObject(service)),
                        },
                    },
                });
            }

            // Click on the push content in the menu
            document.querySelectorAll<HTMLElement>('.js-menu-push-content').forEach($link => {
                $link.addEventListener('click', () => {
                    window._mtm.push({
                        event: 'mise_en_avant_menu',
                        contenu: ($link.parentNode as HTMLElement).innerText,
                        label_bouton: $link.innerText,
                    });
                });
            });
        }
    });
}
